module.exports = __webpack_public_path__ + "static/media/bgwave_rect.c9e79bc3.svg";